import React from 'react';
import { ISMSRole } from '@/services/ismsRolesService';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

interface ISMSRolesTableProps {
  roles: ISMSRole[];
}

const ISMSRolesTable: React.FC<ISMSRolesTableProps> = ({ roles }) => {
  return (
    <div className="rounded-lg">
      <Table className="w-full table" data-table-layout="fixed">
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '70%' }} />
        </colgroup>
        <TableHeader>
          <TableRow>
            <TableHead className="text-left text-xs font-semibold text-foreground">Role Name</TableHead>
            <TableHead className="text-left text-xs font-semibold text-foreground">Description</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {roles.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2} className="py-4 text-center text-muted-foreground text-xs">
                No roles found.
              </TableCell>
            </TableRow>
          ) : (
            roles.map((role) => (
              <TableRow key={role.id} className="hover:bg-accent">
                <TableCell className="align-top text-sm font-medium text-foreground">{role.roleName}</TableCell>
                <TableCell className="align-top text-xs text-muted-foreground whitespace-normal break-words">
                  <div className="min-h-[20px]">
                    {role.roleDescription}
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default ISMSRolesTable;
